document.addEventListener('click', function(e) {
  const btn = e.target.closest('.blog-cta-button');
  if (!btn || typeof gtag !== 'function') return;

  gtag('event', 'blog_cta_click', {
    article_title: document.title,
    cta_topic: btn.dataset.ctaTopic || '',
    cta_name: btn.dataset.ctaName || '',
    cta_text: btn.innerText.trim(),
    cta_url: btn.href || '',
    page_path: window.location.pathname
  });
});

document.addEventListener('click', function(e) {
  const link = e.target.closest('a');
  if (!link || typeof gtag !== 'function') return;

  const href = link.getAttribute('href') || '';
  const linkText = link.innerText.trim();
  const location = link.closest('header') ? 'header' : link.closest('footer') ? 'footer' : 'content';

  if (href.startsWith('tel:')) {
    gtag('event', 'phone_click', {
      link_location: location,
      link_text: linkText,
      phone_number: href.replace('tel:', ''),
      page_path: window.location.pathname
    });
  }

  if (href.startsWith('mailto:')) {
    gtag('event', 'email_click', {
      link_location: location,
      link_text: linkText,
      email_address: href.replace('mailto:', ''),
      page_path: window.location.pathname
    });
  }

  if (linkText.toLowerCase() === 'contact us') {
    gtag('event', 'contact_us_click', {
      button_location: location,
      button_text: linkText,
      page_path: window.location.pathname
    });
  }

  const headerItems = ['how to buy', 'why brody', 'blog'];

  if (headerItems.includes(linkText.toLowerCase())) {
    gtag('event', 'navigation_click', {
      menu_location: 'header',
      menu_item: linkText,
      page_path: window.location.pathname
    });
  }

  if (link.classList.contains('header__nav-dropdown-link')) {
    let menuName = '';

    if (href.includes('/collections/')) {
      menuName = 'Products';
    }

    if (
      href.includes('/pages/service-detail') ||
      href.includes('/pages/white-labeling')
    ) {
      menuName = 'Services';
    }

    if (
      href.includes('/pages/') &&
      !href.includes('/pages/service-detail') &&
      !href.includes('/pages/white-labeling')
    ) {
      menuName = 'Industries';
    }

    if (menuName) {
      gtag('event', 'navigation_menu_click', {
        menu_name: menuName,
        menu_item: linkText || link.getAttribute('aria-label') || '',
        link_url: link.href,
        page_path: window.location.pathname
      });
    }
  }
});